import React, { useState, useEffect } from "react";
import { Container, Row, Col, ListGroup, Collapse } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./adminSidebar.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function AdminSidebar({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = useState(null);

  const adminMenu = [
    {
      label: "공지사항 관리",
      subItems: [
        { label: "공지사항 목록", path: "/admin/notice/list" },
        { label: "공지사항 등록", path: "/admin/notice/write" },
      ],
    },
    {
      label: "회원 관리",
      subItems: [
        { label: "가입 요청 목록", path: "/admin/user/register-request" },
        { label: "회원 목록", path: "/admin/user/list" },
      ],
    },
    {
      label: "결재 관리",
      subItems: [
        { label: "결재 요청 목록", path: "/admin/approval-request/request" },
        { label: "결재 내역", path: "/admin/approval-request/list" },
      ],
    },
    {
      label: "학술 세미나 관리",
      subItems: [
        { label: "학술 세미나 목록", path: "/admin/seminar/list" },
        { label: "학술 세미나 등록", path: "/admin/seminar/write" },
      ],
    },
    {
      label: "연구 프로젝트 관리",
      subItems: [
        { label: "연구 프로젝트 목록", path: "/admin/project/list" },
        { label: "연구 프로젝트 등록", path: "/admin/project/write" },
      ],
    },
    {
      label: "관광 전문가 양성 교육 관리",
      subItems: [
        { label: "관광 전문가 양성 교육 목록", path: "/admin/education/list" },
        { label: "관광 전문가 양성 교육 등록", path: "/admin/education/write" },
      ],
    },
    {
      label: "장학사업 관리",
      subItems: [
        { label: "장학사업 목록", path: "/admin/scholarship/list" },
        { label: "장학사업 등록", path: "/admin/scholarship/write" },
      ],
    },
    {
      label: "관광 취업센터 관리",
      subItems: [
        { label: "관광 취업센터 목록", path: "/admin/job-center/list" },
        { label: "관광 취업센터 등록", path: "/admin/job-center/write" },
      ],
    },
    {
      label: "기타사업 관리",
      subItems: [
        { label: "기타사업 목록", path: "/admin/other-business/list" },
        { label: "기타사업 등록", path: "/admin/other-business/write" },
      ],
    },
    {
      label: "업계소식 관리",
      subItems: [
        { label: "업계소식 목록", path: "/admin/industry-news/list" },
        { label: "업계소식 등록", path: "/admin/industry-news/write" },
      ],
    },
  ];

  useEffect(() => {
    // 현재 경로가 포함된 상위 메뉴 찾기
    const parentMenu = adminMenu.find((menu) =>
      menu.subItems?.some((subItem) =>
        location.pathname.startsWith(subItem.path)
      )
    );

    // 상위 메뉴가 있으면 해당 메뉴를 확장
    if (parentMenu) {
      setExpandedMenu(parentMenu.label);
    }
  }, [location.pathname]);

  const toggleMenu = (label) => {
    setExpandedMenu((prev) => (prev === label ? null : label));
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <Container fluid className="admin-layout">
      <Row>
        {/* 좌측 사이드바 */}
        <Col md={3} className="admin-sidebar">
          <h4 className="text-center mb-3">관리자 메뉴</h4>
          <ListGroup variant="flush">
            {adminMenu.map((menu) =>
              menu.subItems ? (
                <React.Fragment key={menu.label}>
                  {/* 상위 메뉴 */}
                  <ListGroup.Item
                    onClick={() => toggleMenu(menu.label)}
                    className={`admin-sidebar-item ${
                      expandedMenu === menu.label ? "expanded" : ""
                    }`}
                  >
                    <span>{menu.label}</span>
                    <span className="dropdown-icon">
                      {expandedMenu === menu.label ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </span>
                  </ListGroup.Item>
                  {/* 하위 메뉴 */}
                  <Collapse in={expandedMenu === menu.label}>
                    <div>
                      {menu.subItems.map((subItem) => (
                        <ListGroup.Item
                          key={subItem.path}
                          active={location.pathname.startsWith(subItem.path)} // 하위 경로 포함 여부 확인
                          className={`admin-sidebar-subitem ${
                            location.pathname.startsWith(subItem.path)
                              ? "active"
                              : ""
                          }`}
                          onClick={() => navigateTo(subItem.path)}
                        >
                          <div className="sidebar-link">
                            <span className="subitem-icon" /> {subItem.label}
                          </div>
                        </ListGroup.Item>
                      ))}
                    </div>
                  </Collapse>
                </React.Fragment>
              ) : (
                // 단일 항목
                <ListGroup.Item
                  key={menu.path}
                  active={location.pathname === menu.path}
                  className="admin-sidebar-item"
                >
                  <span>{menu.label}</span>
                </ListGroup.Item>
              )
            )}
          </ListGroup>
        </Col>

        {/* 우측 콘텐츠 */}
        <Col md={9} className="admin-content">
          {children}
        </Col>
      </Row>
    </Container>
  );
}
